import type { ProjectileHittable } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class InvisibleWall extends PhysicalThing implements ProjectileHittable {
	static key = "InvisibleWall";
	constructor(xy: XY) {
		super(xy, true);
	}

	isVisible(): boolean {
		return false;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}

	static deserialize(data: any): InvisibleWall {
		const w = new InvisibleWall(deserializeXY(data.xy));
		w.visualId = data.visualId;
		return w;
	}
}
